import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export const BASE_BUILDING_PLACES_QUERY_KEY = 'useGetBuildingPlaces'

export const getClientsWithCountQueryKey = (buildingId: string) => [
  BASE_BUILDING_PLACES_QUERY_KEY,
  buildingId,
]

export interface Place {
  buildingId: number
  id: number
  name: string
}

const getBuildingPlaces = async ({
  buildingId,
  signal,
}: {
  buildingId: string
  signal?: AbortSignal
}) => {
  const response = await authAPI.get<Place[]>(`/guest-pass/${buildingId}/place`, {
    signal,
  })
  return response.data
}

export const useGetBuildingPlaces = (buildingId?: string, options?: UseQueryOptions<Place[]>) => {
  return useQuery<Place[]>({
    enabled: !!buildingId,
    placeholderData: [],
    queryFn: ({ signal }) => getBuildingPlaces({ buildingId: buildingId ?? '', signal }),
    queryKey: getClientsWithCountQueryKey(buildingId ?? ''),
    ...options,
  })
}
